import { ChangeDetectionStrategy, Component, inject, input, model, output} from '@angular/core';
import { AbstractComponent } from '@spike/scaffolds';
import { TableModule } from 'primeng/table';
import { Tag } from 'primeng/tag';
import { OrganizationStoreService } from '../../../organizations/services/organization-store.service';
import { Button } from "primeng/button";
import { CommonModule } from '@angular/common';
import { EquipmentRequest } from '../../models/equipment-request.model';
import { SortingModel } from 'src/app/features/shared/models/sorting.model';
import { EquipmentRequestWorkflow } from 'src/app/features/workflow/models/workflow-status.enum';


@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-equipment-requests-table',
  providers:[],
  imports: [TableModule, Tag, Button, CommonModule],
  templateUrl: './equipment-requests-table.html'
})

export class EquipmentRequestsTableComponent extends AbstractComponent{
  public readonly organizationStore = inject(OrganizationStoreService)
  minimal = input.required<boolean>(); 
  items = input.required<EquipmentRequest[]>();
  onSelect = output<EquipmentRequest>();
  onDelete = output<EquipmentRequest>();

  sorting = model.required<SortingModel>();

  sort(event: any){
    this.sorting.set({ orderByClause: event.field, orderDirection: event.order === 1 ? 'asc' : 'desc' });
  }

  getRequestStatusSeverity(stateId:number): 'secondary' | 'success' | 'info' | 'warn' | 'danger' {  
    return EquipmentRequestWorkflow.find(x => x.id == stateId)?.severity ?? 'info';
  }

  getRequestStatusDescription(stateId:number): string | undefined {
    return EquipmentRequestWorkflow.find(x => x.id == stateId)?.label;
  } 



}
  

